module.exports = __webpack_public_path__ + "static/media/check.7abf4547.svg";